import React, { SVGProps } from 'react'
const SvgThumbsDown = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={14}
    height={14}
    aria-hidden="true"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_117_457)">
      <path
        d="M9.91678 1.16666V7.58332M12.8334 5.71666V3.03332C12.8334 2.37993 12.8334 2.05323 12.7063 1.80367C12.5944 1.58415 12.416 1.40567 12.1964 1.29382C11.9469 1.16666 11.6202 1.16666 10.9668 1.16666H4.73562C3.88309 1.16666 3.45682 1.16666 3.11253 1.32266C2.80909 1.46015 2.5512 1.6814 2.36917 1.96041C2.16263 2.27697 2.09781 2.69828 1.96818 3.5409L1.66305 5.52423C1.49207 6.63559 1.40658 7.19127 1.5715 7.62364C1.71625 8.00314 1.98849 8.32048 2.34157 8.52125C2.74384 8.74999 3.30606 8.74999 4.43049 8.74999H4.90011C5.22681 8.74999 5.39016 8.74999 5.51494 8.81357C5.6247 8.8695 5.71394 8.95873 5.76987 9.06849C5.83345 9.19328 5.83345 9.35663 5.83345 9.68332V11.3949C5.83345 12.1893 6.47744 12.8333 7.27185 12.8333C7.46133 12.8333 7.63304 12.7217 7.71 12.5486L9.67044 8.13759C9.7596 7.93697 9.80419 7.83665 9.87466 7.7631C9.93695 7.69808 10.0135 7.64837 10.0982 7.61785C10.194 7.58332 10.3038 7.58332 10.5233 7.58332H10.9668C11.6202 7.58332 11.9469 7.58332 12.1964 7.45616C12.416 7.34431 12.5944 7.16583 12.7063 6.94631C12.8334 6.69675 12.8334 6.37005 12.8334 5.71666Z"
        stroke={props.stroke || '#4F3FDD'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_117_457">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgThumbsDown
